import '../../assets/index34.css';var I = Object.defineProperty, P = Object.defineProperties;
var T = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var L = Object.prototype.hasOwnProperty, S = Object.prototype.propertyIsEnumerable;
var C = (r, e, s) => e in r ? I(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, n = (r, e) => {
  for (var s in e || (e = {}))
    L.call(e, s) && C(r, s, e[s]);
  if (d)
    for (var s of d(e))
      S.call(e, s) && C(r, s, e[s]);
  return r;
}, i = (r, e) => P(r, T(e));
var R = (r, e) => {
  var s = {};
  for (var t in r)
    L.call(r, t) && e.indexOf(t) < 0 && (s[t] = r[t]);
  if (r != null && d)
    for (var t of d(r))
      e.indexOf(t) < 0 && S.call(r, t) && (s[t] = r[t]);
  return s;
};
import { jsx as p } from "react/jsx-runtime";
import { Link as U } from "../Link/index.js";
import { ChevronRightFAIcon as w } from "../Icons/index.js";
import { u as F, a as H } from "../../chunk-KNED5TY2-CXwb6gAr.js";
import { T as V } from "../../Text-B7Ta53Id.js";
import { Children as q, cloneElement as G, createElement as $ } from "react";
import { i as J } from "../../is-element-C00Aie10.js";
import { b as K } from "../../get-size-Bc1Pz5yf.js";
import { c as O } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as Q, u as W, B as A } from "../../factory-ueRxoNOV.js";
import { u as X } from "../../use-styles-DToiHEa6.js";
var M = { root: "m_8b3717df", breadcrumb: "m_f678d540", separator: "m_3b8f2208" };
const Y = {
  separator: "/"
}, Z = O((r, { separatorMargin: e }) => ({
  root: {
    "--bc-separator-margin": K(e)
  }
})), y = Q((r, e) => {
  const s = W("Breadcrumbs", Y, r), N = s, {
    classNames: t,
    className: _,
    style: l,
    styles: g,
    unstyled: a,
    vars: o,
    children: c,
    separator: m,
    separatorMargin: v
  } = N, B = R(N, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "children",
    "separator",
    "separatorMargin"
  ]), u = X({
    name: "Breadcrumbs",
    classes: M,
    props: s,
    className: _,
    style: l,
    classNames: t,
    styles: g,
    unstyled: a,
    vars: o,
    varsResolver: Z
  }), j = q.toArray(c).reduce((h, b, f, z) => {
    var k;
    const D = J(b) ? G(b, i(n({}, u("breadcrumb", { className: (k = b.props) == null ? void 0 : k.className })), {
      key: f
    })) : /* @__PURE__ */ $("div", i(n({}, u("breadcrumb")), { key: f }), b);
    return h.push(D), f !== z.length - 1 && h.push(
      /* @__PURE__ */ $(A, i(n({}, u("separator")), { key: `separator-${f}` }), m)
    ), h;
  }, []);
  return /* @__PURE__ */ p(A, i(n(n({ ref: e }, u("root")), B), { children: j }));
});
y.classes = M;
y.displayName = "@mantine/core/Breadcrumbs";
const x = "Breadcrumbs-module__root___DCUsM", rr = "Breadcrumbs-module__separator___CRwiN", E = {
  root: x,
  separator: rr
};
function br({ items: r, labelMap: e = {} }) {
  const s = F(), t = H(), l = (() => {
    if (r) return r;
    const a = s.pathname.split("/").filter(Boolean), o = n({
      settings: "Settings",
      security: "Security"
    }, e);
    return a.map((c, m) => {
      const v = `/${a.slice(0, m + 1).join("/")}`;
      return {
        label: o[c] || c.charAt(0).toUpperCase() + c.slice(1),
        to: m === a.length - 1 ? void 0 : v
      };
    });
  })();
  s.pathname !== "/" && !r && l.unshift({ label: "Home", to: "/" });
  const g = l.map((a, o) => o === l.length - 1 || !a.to ? /* @__PURE__ */ p(V, { c: "gray.7", size: "sm", children: a.label }, o) : /* @__PURE__ */ p(
    U,
    {
      variant: "inline",
      onClick: (m) => {
        m.preventDefault(), a.to && t(a.to);
      },
      className: E.link,
      children: a.label
    },
    o
  ));
  return /* @__PURE__ */ p(
    y,
    {
      classNames: E,
      separator: /* @__PURE__ */ p(w, { size: 8 }),
      children: g
    }
  );
}
export {
  br as Breadcrumbs
};
